import { Typography } from '@/components';
import { TextStyles } from '@/constants';
import type { CSSProperties } from 'react';
import styled from 'styled-components';

const ellipsis: CSSProperties = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export const Chip = styled.div<{ colorScheme?: string }>(({ colorScheme, theme }) => ({
  display: 'flex',
  height: 'fit-content',
  width: 'fit-content',
  maxWidth: '100%',
  borderRadius: '4px',
  backgroundColor: colorScheme,
  padding: `${theme.spacing[4]} ${theme.spacing[8]}`,
  marginBottom: theme.spacing[8],
}));

export const ChipText = styled(Typography).attrs({
  variant: TextStyles['Heading 6'],
})(({ theme }) => ({
  ...ellipsis,
  marginLeft: theme.spacing[4],
  color: theme.colors.highEmphasisWhite,
  textTransform: 'uppercase',
}));
